<template>
  <div class="MyMission">
    <my-header title="上传截图" :platform="platform" backType="app"></my-header>
    <div class="task-ban" ref="taskBan">
      <van-swipe :loop="true"  class="swiper" :show-indicators="false" >
        <van-swipe-item @click="goCard(item)" class="task-ban-item" v-for="(item,index) in bannerList" :key="index">
            <img :src="item.imgUrl"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="task-entrance" v-if="!entranceIs">
      <img v-for="(item,index) in taskTypeList" @click="goTask(item)" :key="index" :src="item.typeImgUrl" alt="">
    </div>
    <div class="task-con"  v-if="entranceIs">
      <div class="mm_tab flex_sb" :style="fixedIs?'position:fixed;':'position:inherit;'">
        <div
          class="mm_tabitem"
          :class="tab_active_index == index ? 'active' : ''"
          v-for="(item, index) in tablist"
          :key="index"
          :data-index="index + 1"
          @click="change_tab"
        >
          {{ item }}
        </div>
        <img
          src="/static/mymission/btn_jiangli.png"
          class="btn_jiangli"
          @click="href_reward"
        />
      </div>
    </div>
    <div class="login-out" v-if="loginOutIs">当前账户：<span class="user-account">{{userinfo.userAccount}}</span><br><span @click="loginOut" class="out-current">切换账户</span></div>
    <Login
      :code_list="code_list"
      hide_warn="yes"
      :openid="openid"
      v-if="login_s"
      :closeHide="true"
      @register="register"
      @close="hide_win"
      @havelogin="havelogin"
    />
    <Register
      :code_list="code_list"
      :fromuid="fromuid"
      hide_warn="yes"
      :openid="openid"
      :closeHide="true"
      appid="公众号内功能注册"
      v-if="register_s"
      @login="login"
      @close="hide_win"
      @haveregister="haveregister"
    />
  </div>
</template>
<script>
import { List, Cell,Swipe,SwipeItem } from "vant";
import MyHeader from "../common/MyHeader/MyHeader"
import http from "../../../service/http";
import Login from "../common/login/login";
import Register from "../common/register/register";
export default {
  name: "MyMission",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Swipe.name]:Swipe,
    [SwipeItem.name]: SwipeItem,
    Login,
    Register,
    MyHeader
  },
  data() {
    return {
      tablist: ["进行中", "未开始", "已完成", "已过期"], //tab列表数据（固定数据）
      tab_active_index: 0, //处于选中状态tab的序号
      userinfo: {}, //用户的基本信息
      loading: false,
      finished: false, //是否已加载完成
      taskState: 1, //当前对应任务状态任务状态 1=进行中 2=未开始 3=已完成 4=已过期
      page: 1, //当前列表页码
      ajaxurl: "https://apinew.koalaknow.com/api/OfficialWebSite/InterfaceV1",

      code_list: [], //国家区号列表
      login_s: false, //展示登录
      register_s: false, //展示注册
      mm_list: [], //当前页面列表
      fromuid: "", //来源id
      fixedIs:false,
      bannerList:[],//banner
      entranceIs:false,
      taskTypeList:[],
      openid:'',
      platform:''
    };
  },
  computed: {
      loginOutIs() {
        return this.userinfo&&this.platform.indexOf('ios')<0
     }   
  },
  created() {
    localStorage.removeItem('userinfo')
    document.title = "上传截图";
    this.getTaskCategoryTypeList()
    this.platform = this.$route.query.platform || ''
  },
  mounted() {
    let that=this
    if(http.getQueryString("guid")){
      that.getusersmall_uid(http.getQueryString("guid"));
    }else{
      this.getopenid();
    }
  },
  
  methods: {
    //获取用户openid
    getopenid() {
      if (http.getQueryString("openid")) {
        this.openid=http.getQueryString("openid")
        this.LoadInit(http.getQueryString("openid"));
      } else {
        var msg = "https%3a%2f%2fwww.koalaknow.com%2fMobile%2fIntermediary";
        // window.location.href='https://www.koalaknow.com/DoVChar/GetWechatOpenId?url='+msg
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3d92e9bbedce149e&redirect_uri=" +
          msg +
          "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
      }
    },
    LoadInit(openID) {
      var that=this;
      $.ajax({
        type: "POST",
        url: "https://www.koalaknow.com/Personal_MyClASS_Do/GetUserOpenID",
        data: { openID: openID },
        success: function (msg) {
          if (msg != "-1") {
            // that.getuser();
            that.getusersmall_uid(msg);
          } else {
            that.getuser();
          }
        },
      });
    },
    //获取用户短id
    getusersmall_uid(guid){
      var url="https://apinew.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1";
      var data={
        cmd:'GetUserInfoByGuid',
        userGuid:guid
      },
      that=this;
      http.req(data,(res)=>{
        localStorage.setItem("userinfo", JSON.stringify(res.info));
        var userinfo = localStorage.getItem("userinfo")
        that.userinfo=JSON.parse(userinfo);
        // that.getBannerList()
        setTimeout(()=>{
          that.havelogin();
        },500)
      },url)
    },
    //展示window
    notice() {
      // $(".rule_w").show();
      window.location.href='/MyMissionRule'
      // window.location.href='https://www.koalaknow.com/img/guize.pdf'
    },
    //隐藏window
    click_back() {
      $(".rule_w").hide();
    },
    //获取用户登录状态
    getuser() {
        var userinfo = localStorage.getItem("userinfo"),
        that = this;
        if(userinfo){
            userinfo=JSON.parse(userinfo)
        }
        var imgUrl = "https://www.koalaknow.com/img/VcharImg/vcharlogo.png"; // 分享图标
        var title = "为孩子报名",
            desc = "专业老师，专属课程，爱上“动起来”的中文";
        if (!userinfo) {
            http.get_codelist((res) => {
                that.code_list = res.list;
                that.login_s = true;
            });
            if(http.getQueryString("openid")){
                http.wxshare(
                    "",
                    "https://official.koalaknow.com/MyMission",
                    title,
                    desc,
                    imgUrl
                );
            }
            
        } else {
            this.userinfo = userinfo;
            if(http.getQueryString("openid")){
            http.wxshare(
                userinfo.userId,
                "https://official.koalaknow.com/MyMission?uid=" +
                userinfo.userId,
                title,
                desc,
                imgUrl
            );
        }
        this.TaskListCount();
        this.getBannerList()
      }
      if (http.getQueryString("uid")) {
        this.fromuid = http.getQueryString("uid");
        console.log(this.fromuid);
      }
    },
    // 切换账户
    loginOut(){
        localStorage.setItem("userinfo",'')
        this.userinfo=null
        this.getuser()
    },
    onLoad(item) {
        var userinfo = localStorage.getItem("userinfo")
        userinfo=JSON.parse(userinfo);
      if (userinfo&&userinfo.userGuid) {
        var data = {
            cmd: "GetUserTaskListByPage",
            userGuid: userinfo.userGuid,
            taskState: this.taskState,
            page: this.page,
            pageSize: 10,
            taskId:item&&item.typeId,
          },
          that = this;

        that.page = that.page + 1;
        http.req(
          data,
          function (res) {
            if (res.list.length > 0) {
              that.mm_list = that.mm_list.concat(res.list);
              that.loading = false;
            } 
            if(res.list.length<10){
              that.finished = true;
            }
          },
          this.ajaxurl
        );
      }
    },
    //获取当前各个打卡任务任务数量
    TaskListCount() {
      var data = {
          cmd: "GetUserTaskListCount",
          userGuid: this.userinfo.userGuid,
      },
      that = this;
      http.req(
        data,
        (res) => {
          that.tablist = [
            "进行中(" + res.enyJinXingZhong + ")",
            "未开始(" + res.enyWeiKaiShi + ")",
            "已完成(" + res.enyYiWanCheng + ")",
            "已过期(" + res.enyYiGuoQi + ")",
          ];
        },
        this.ajaxurl
      );
    },
    //点击去查看奖励页面
    href_reward() {
      if (this.userinfo) {
        window.location.href = "/MyReward";
      } else {
        that.login_s = true;
      }
    },
    //点击去任务详情
    href_detail(e) {
      var title = e.currentTarget.dataset.title;
      var taskid = e.currentTarget.dataset.id;
      window.location.href =
        "/MyMissionDetail?title=" + title + "&id=" + taskid;
    },
    //切换tab
    change_tab(e) {
      var index = e.target.dataset.index;
      this.taskState = index;
      this.tab_active_index = index - 1;
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.mm_list = [];
      this.onLoad();
    },
    //点击去注册
    register(e) {
      this.login_s = false;
      this.register_s = true;
    },
    //去登陆
    login() {
      this.login_s = true;
      this.register_s = false;
    },
    //登录成功
    havelogin() {
      this.login_s = false;
      this.register_s = false;
      this.getuser();
      this.onLoad();
      
    },
    //注册成功
    haveregister() {
      this.login_s = false;
      this.register_s = false;
      this.getuser();
      this.onLoad();
    },
    hide_win() {
    },
    // 去星座卡
    goCard(item) {
        
      window.location.href=item.imgParam.replace(/platform=\S*&/,`platform=mymission${this.platform}&`)
      // this.$router.push({path:'/card',query:{guid:this.userinfo.userGuid}})
    },
    // 获取banner
    getBannerList(){
      let url='https://apinew.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1'//正式
      // let url='https://apinewtest.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1'//测试
      let data={
          cmd: "GetBannerListByCategory",
          userGuid: this.userinfo.userGuid,
          bannerCategory:"enyWDRW_WX",
      }
      http.req(data,(res)=>{
        this.bannerList=res.list
      },url)
    },
    // 任务入口
    getTaskCategoryTypeList(){
      let url="https://apinew.koalaknow.com/api/OfficialWebSite/InterfaceV1"
      let data={
        cmd:"GetUserTaskCategoryTypeList",
      }
      http.req(data,res=>{
        this.taskTypeList=res.list
      },url)
    },
    goTask(item){
      let queryData={taskId:item.typeId,title:item.typeName,platform:this.platform}
      if(http.getQueryString("guid")){
        queryData.guid=http.getQueryString("guid")
      }else{
        queryData.openid=http.getQueryString("openid")
      }
      this.$router.push({path:'/MyMissionList',query:queryData})
    }
  },
};
</script>
<style scoped>

.w_content {
  background: #fff;
  width: 80%;
  border-radius: 10px;
  padding: 30px 30px 10px;
  box-shadow: border-box;
  font-size: 24px;
  line-height: 42px;
}
.w_content .p1 {
  font-weight: bold;
}
.w_content .p2 {
  color: #666;
}
.w_content .back {
  width: 200px;
  height: 70px;
  background: #e0382d;
  border-radius: 44px;
  color: #fff;
  text-align: center;
  line-height: 70px;
  margin: 30px auto;
}
.MyMission {
  min-height: 100vh;
  background: #f4f4f4;
}
.mm_tab {
  height: 80px;
  background: #ffffff;
  color: #333333;
  font-size: 28px;
  line-height: 80px;
  padding: 0 0 0 30px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  z-index: 2;
  width: 100%;
}
.mm_tab .mm_tabitem {
  padding: 0 10px;
  box-sizing: border-box;
}
.mm_tab .active {
  border-bottom: 4px solid #ff2424;
}
.mm_tab .btn_jiangli {
  width: 96px;
  height: 80px;
  margin: 0;
}
.mm_list {
  padding: 100px 30px 20px;
  box-sizing: border-box;
}
.mm_list .mm_liitem {
  padding: 25px 30px 29px;
  box-sizing: border-box;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.16);
  border-radius: 20px;
  background: #fff;
  margin: 20px 0;
  position: relative;
}
.mm_list .img_left {
  width: 128px;
  height: 128px;
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
}
.mm_list .mm_btn {
  width: 144px;
  height: 100px;
  background: #e0382d;
  border-radius: 20px;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  /* line-height: 100px; */
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.mm_list .mm_isup {
  background: #999;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
}
.mm_list .mml_center {
  flex: 1;
  -webkit-flex: 1;
  margin: 0 20px;
}
.mm_list .mml_center .title {
  color: #333;
  font-size: 32px;
  font-weight: bold;
  line-height: 42px;
}
.mm_list .mml_center .desc {
  margin: 16px 0 12px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.mm_list .mml_center .time,
.mm_list .mml_center .desc {
  color: #666;
  font-size: 24px;
  line-height: 31px;
}
.mm_list .mm_img {
  width: 181px;
}
.mm_list .mm_img img {
  width: 181px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.notice {
  position: fixed;
  right: 30px;
  bottom: 100px;
}
.notice img {
  width: 214px;
}
.task-ban-item img{
  display: block;
  width: 100%;
  height: 382px;
}

.task-entrance{
  padding: 29px 12px;
}
.task-entrance img{
  width: 100%;
  display: block;
  margin-bottom: 6px;
}


.login-out{
    font-size: 28px;
    text-align: center;
    padding: 0.1rem 0 ;
    line-height: 40px;
}
.out-current{
    color: #f43737;
    padding: 0.2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/content/MyMission.vue